// TODO: Import tokens from @shopify/polaris-tokens when version 6 is released
// These tokens are hardcoded based on @shopify/polaris-tokens (version 5)
// The reason not to use the library is that it requires to load
// all the tokens in order to grab just a couple of them.
// This has negative performance consequences.
// With the version 6 release, we should be able to import only the
// tokens we actually use.

// Source: https://github.com/Shopify/polaris/blob/main/polaris-tokens/src/token-groups/spacing.ts
const SPACING_TOKENS = {
  'space-2': '8px',
  'space-8': '32px'
};

export { SPACING_TOKENS };
